import {_Admin} from "./Admin/_Admin";

export const UsersModuleEventsAPI = {
    Admin:_Admin
}